/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PropertyLocalCreate } from './propertyLocalCreate';
import type { PropertyValueIn } from './propertyValueIn';

export interface PropertiesPut {
  values: PropertyValueIn[];
  create?: PropertyLocalCreate[];
}
